// src/components/GoldReport.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchReportData } from '../services/reportService';
import Header from './report/Header';
import SummaryCards from './report/SummaryCards';
import InvestmentChart from './report/InvestmentChart';
import GoldPurchaseHistory from './report/GoldPurchaseHistory';
import InvestmentGrowth from './report/InvestmentGrowth';
import ValueBreakdown from './report/ValueBreakdown';
import DeliveredTargets from './report/DeliveredTargets';
import OpportunityInsights from './report/OpportunityInsights';
import SavingsLevelClassification from './report/SavingsLevelClassification';
import SavingPotential from './report/SavingPotential';
import LongTermProjection from './report/LongTermProjection';
import SavingsJourney from './report/SavingsJourney';
import PlanningCTA from './report/PlanningCTA';
import WelcomeStats from './report/WelcomeStats';





function GoldReport() {
    const { slug } = useParams();
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadReportData = async () => {
            try {
                setLoading(true);
                const data = await fetchReportData(slug);
                setReportData(data);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to load report data');
            } finally {
                setLoading(false);
            }
        };

        if (slug) {
            loadReportData();
        }
    }, [slug]);

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!reportData) return null;


    return (
        <div className="min-h-screen bg-[#234363]">
            <div className="container mx-auto px-4 py-8 space-y-6">
                <Header 
                    customerName={reportData.customerInfo.name}
                    membershipDuration={reportData.customerInfo.membershipDuration}
                />
                <WelcomeStats />
                <SummaryCards metrics={reportData.metrics} purchaseMetrics={reportData.purchase_metrics}/>
                <SavingsJourney reportData={reportData} />
                <InvestmentChart data={reportData.investments.monthly} />
                <LongTermProjection reportData={reportData} />
                <InvestmentGrowth 
                    yearComparison={reportData.investments.yearlyComparison}
                    growthAnalysis={reportData.investments.growth}
                />
                <DeliveredTargets targets={reportData.deliveredTargets} />
                <PlanningCTA />

                
            </div>
        </div>
    );
}

export default GoldReport;